import lodash from "lodash";
import {
    createFieldRadioGroup,
    createFieldTextArea
} from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import store from "../../../../../../store";
import { conditionFormChecker, putField } from "../../../../../../utils/form";

export const callCancelSequestrateResult = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "CANCEL_SEQUESTRATE_RESULT", value: searchQuery });
export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refResult`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.cancelSequestrate.refResult"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refResult,
                            "onUpdate:value": value => (model.refResult = value),
                            disabled: viewOnly,
                            list: callCancelSequestrateResult,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}cause`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.cancelSequestrate.cause"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.cause,
                            "onUpdate:value": value => (model.cause = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}activity`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.cancelSequestrate.activity"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.activity,
                            "onUpdate:value": value => (model.activity = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}followDetail`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.cancelSequestrate.followDetail"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.followDetail,
                            "onUpdate:value": value => (model.followDetail = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};
